import { ChooseMember } from 'app/src/components/ChooseMember';
import PopOver from 'app/scripts/views/lib/pop-over.coffee';
import React from 'react';
import Util from 'app/scripts/lib/util/index.coffee';
import { trackUe, Noun, Verb } from '@trello/analytics';
import { AdvancedChecklistsBetaInfo } from './advanced-checklists-beta-info';

function bind<T extends (...args: unknown[]) => unknown>(
  fn: T,
  context: unknown,
): T {
  return fn.bind(context);
}

interface OptionsV2 {
  title: string;
  trackingMethod: string;
  getCardMembers: (this: unknown) => Member[];
  getBoardMembers: (this: unknown) => Member[];
  getInitialMember: () => string | undefined | null;
  setMember: (value: string | null) => void;
}

export function toggleAssignPopoverV2(options: OptionsV2) {
  const { title, trackingMethod } = options;

  return function toggle(e: MouseEvent) {
    Util.stop(e);

    const setMember = bind(options.setMember, this);
    const getInitialMember = bind(options.getInitialMember, this);

    const getCardMembers = bind(options.getCardMembers, this);
    const getBoardMembers = bind(options.getBoardMembers, this);

    const idMemberInitial = getInitialMember();

    trackUe(
      Noun.CARD_DETAIL,
      Verb.OPENS,
      idMemberInitial
        ? Noun.CHANGE_MEMBER_DIALOGUE
        : Noun.ASSIGN_MEMBER_DIALOGUE,
      'on checkitem',
      '',
      trackingMethod,
    );

    PopOver.toggle({
      elem: e.currentTarget,
      getViewTitle: () => title,
      keepEdits: true,
      reactElement: (
        <React.Fragment key="choose-member">
          <ChooseMember
            {...{
              idMemberInitial,
              getCardMembers,
              getBoardMembers,
            }}
            onSelect={(member) => {
              PopOver.hide();

              if (member && member.id !== idMemberInitial) {
                setMember(member.id);
              } else if (!member && idMemberInitial) {
                setMember(null);
              }
            }}
          />
          <AdvancedChecklistsBetaInfo />
        </React.Fragment>
      ),
    });
  };
}

interface Member {
  id: string;
  fullName: string;
  username: string;
}
